import { cloneElement, type ReactElement } from 'react';
import { Tooltip } from '@cowbell/ui';

import { TABLE_CELL_TOOLTIP_LAYER } from '../../../components/tables/TableCellTooltip';

interface RailTooltipProps {
  readonly railCollapsed: boolean;
  readonly title: string;
  readonly children: ReactElement<Record<string, unknown>>;
}

/** Keyboard users tabbing down the rail get the name too. */
const RAIL_TOOLTIP_EVENTS = { hover: true, focus: true, touch: false };

/**
 * The icon-only rail hides every label, so the name moves to a hover tooltip.
 * Expanded, the label is on screen and the row renders unchanged.
 *
 * Every sidebar row goes through this -- the Cowbell nav, the policyholder nav,
 * the footer and flyout parents -- so the rule is answered in one place.
 */
export function RailTooltip({
  railCollapsed,
  title,
  children,
}: RailTooltipProps) {
  if (!railCollapsed) {
    return children;
  }

  // The rail hides the label with `display: none`, which also takes it out of
  // the row's accessible name, so the row is named here instead.
  return (
    <Tooltip
      label={title}
      position="right"
      events={RAIL_TOOLTIP_EVENTS}
      zIndex={TABLE_CELL_TOOLTIP_LAYER}
    >
      {cloneElement(children, { 'aria-label': title })}
    </Tooltip>
  );
}
